import { createFileRoute } from '@tanstack/react-router';
import ProvidedJobPostsEditTemplate from '@/features/agent/provided_job_posts/templates/ProvidedJobPostsEditTemplate';

export const Route = createFileRoute('/agent/provided_job_posts/$providedJobPostsId/edit/')({
  component: ProvidedJobPostsEdit,
});

function ProvidedJobPostsEdit() {
  const { providedJobPostsId } = Route.useParams();

  return <ProvidedJobPostsEditTemplate id={providedJobPostsId} />;
}
